$('[data-cardSelectButton]').click(function () {
	$(this).parent('[data-cardSelect]').toggleClass('is-selected');
});

import $ from 'jquery';
import _ from 'lodash';

/**
 * Toggles the visual display of an element on the page.
 * Contains action directives for interacting with a toggler element:
 *  - toggler-open
 *  - toggler-close
 *  - toggler-toggle
 *  - toggler-select
 *
 * @param context
 */
export default function checkoutDirective(context = document.body) {
	const $context = $(context);
	const $scroller = $('html, body');

	function cancelAnimation() {
		window.removeEventListener('mousewheel', cancelAnimation);
		$scroller.stop();
	}

	let businessInputs = $('.business-address textarea, .business-address input, .business-address select');

	$('[data-buttonselect]').click(_.debounce(function () {
		if ($(this).closest('.prod_card').hasClass('-is-selected')) {
			$(this).closest('.prod_card').toggleClass('-is-selected');
		} else {
			let $block = $(this).parents('.body_block').next();

			// If there are no more blocks in the group, then find the next group
			// with cards, otherwise, we've reached the end
			if (!$block.length) {
				// Select the next body_group
				$block = $(this).parents('.body_group').next();

				// If this group has no cards, but a subsequent group does, then
				// find it and select it
				if ((!$block.find('.body_cards').length) && ($block.nextAll().find('.body_cards').length)) {
					$block = $block.nextAll().find('.body_cards').first().parents('.body_group');
				}
			}

			$(this).closest('.grid').find('.-is-selected').removeClass('-is-selected');
			$(this).closest('.prod_card').toggleClass('-is-selected');

			const blockOffset = $block.offset().top;
			const blockHeight = $block.height();
			const windowHeight = $(window).height();
			const margin = parseInt($block.css('margin-top'));
			let scrollTop = blockOffset + (blockHeight / 2) - (windowHeight / 2);

			if (blockHeight > windowHeight) {
				scrollTop = blockOffset - (margin / 2);
			}

			window.addEventListener('mousewheel', cancelAnimation);

			setTimeout(() => {
				$scroller.animate({ scrollTop }, {
					duration: 1200,
					complete: () => {
						window.removeEventListener('mousewheel', cancelAnimation);
					}
				});
			}, 200);
		}
		calculateCartTotals();
	}, 100));

	$('[data-buttonextraselect]').click(function () {
		let qtyEl = $(this).prev().children().first();
		let card = $(this).closest('.prod_card');
		if (qtyEl.length) {
			if (qtyEl.val() <= 0) {
				if (!card.hasClass('-is-selected')) {
					alert('Quantity required');
				}
				//$(this).closest('.prod_card').removeClass('-is-selected');
				$(this).parent().parent().parent('[data-productselect]').removeClass('-is-selected');
			} else {
				//$(this).closest('.prod_card').toggleClass('-is-selected');
				if (!$(this).closest('.prod_card').hasClass('-is-selected')) {
					$(this).parent().parent().parent('[data-productselect]').addClass('-is-selected');
					// qtyEl.val(0);
				}
			}
		}
		calculateCartTotals();
	});

	$('[data-showfeatures]').click(function () {
		if ($(this).text().toLowerCase().indexOf("show more") >= 0) {
			$(this).parent().find('.comparison_card_content_body li').attr('style', 'display:block');
			$(this).text('Show less');
		} else {
			$(this).parent().find('.comparison_card_content_body li').attr('style', 'display:none');
			$(this).parent().find('.comparison_card_content_body li:first-child').attr('style', 'display:block');
			$(this).parent().find('.comparison_card_content_body li:nth-child(2)').attr('style', 'display:block');
			$(this).parent().find('.comparison_card_content_body li:nth-child(3)').attr('style', 'display:block');
			$(this).text('Show more');
		}
	});

	$('[data-address-duplicate]').click(function () {
		const $this = $(this),
			businessAddress = $('[data-business-address]').find('.business-address'),
			$container = $this.closest('.column.text'),
			shippingAddress = $container.find('.address-form'),
			billingAddress = $container.find('.billing-address-form');

		let address = {};
		let model = '';

		if (shippingAddress.length > 0) {
			address = shippingAddress;
			model = 'shippingAddress';

		} else {
			address = billingAddress;
			model = 'billingAddress';
		}

		address = setupAddress(address, model);

		if ($(this).is(":checked")) {
			address.form.attr('style', 'opacity: 0.3');
			address.form.addClass('address-copied');

			setupAddressFieldValues(address, businessAddress);

		} else {
			address.form.attr('style', 'opacity: 1');
			address.form.removeClass('address-copied');
			address.business_address.val('Street Address include suite, Level and Building name if applicable').change();
			address.town_suburb.val('').change();
			address.state.val('').change();
			address.postcode.val('');
			address.country.val('').change();
		}
	});

	// console.log(businessInputs);
	businessInputs.on('change input', function(){
		let businessAddress = $('.business-address');
		$('.address-copied').each(function(){
			// make sure it is checked
			const $this = $(this);

			let isShipping = $this.hasClass('address-form');
			let model = isShipping ? 'shippingAddress' : 'billingAddress';
			let address = setupAddress($this, model);

			setupAddressFieldValues(address, businessAddress);
		})
	});

	$('.product_qty input').change(function () {
		let qty = $(this).val();
		let qtyHidden = $(this).parent().parent().find('.update-cart .qty');
		qtyHidden.val(qty);
	});

	$(window).on('load', function () {
		if (typeof window.cartItems != 'undefined' && window.cartItems.length) {
			window.cartItems.forEach(function (item) {
				$('.prod_card').each(function (o) {
					let i = JSON.parse(item);
					if ($(this).data('purchaseid') == i.productId) {
						$(this).toggleClass('-is-selected');
						$(this).find('.product_qty input').val(i.qty);
					}
				});
			})
		}

		calculateCartTotals();
	});
}

function setupAddress(form, model) {
	return {
		form: form,
		model: model,
		business_address: form.find(`textarea[name="${model}[address1]"]`),
		town_suburb: form.find(`input[name="${model}[city]"]`),
		state: form.find(`select[name="${model}[stateValue]"]`),
		postcode: form.find(`input[name="${model}[zipCode]"]`),
		country: form.find(`select[name="${model}[countryId]"]`)
	}
}

function setupAddressFieldValues(address, form) {
	address.business_address.val(form.find('textarea[name="fields[address]"]').val()).change();
	address.town_suburb.val(form.find('input[name="fields[townSuburb]"]').val()).change();

	let val = form.find('select[name="fields[state]"]').val();
	address.state.find("option").each(function () {
		if ($(this).text() === val) {
			$(this).attr("selected", "selected").change();
		}
	});

	address.postcode.val(form.find('input[name="fields[postcode]"]').val()).change();

	val = form.find('select[name="fields[country]"]').val();
	address.country.find("option").each(function () {
		if ($(this).text() === val) {
			$(this).attr("selected", "selected").change();
		}
	});
}

export function calculateCartTotals() {
	// calculate totals based on the items in the cart
	let payableCost = $('.payable-cost');
	let setupCost = 0;
	let addToTotal = [];
	let firstTime = true;

	if (typeof window.cartItems != 'undefined' && window.cartItems.length && firstTime) {
		window.cartItems.forEach(function (item) {
			let i = JSON.parse(item);
			if ($(`[data-purchaseid=${i.productId}]`).length === 0) {
				setupCost = setupCost + parseFloat(i.setupCost);
				addToTotal.push(i.productId);
			}
		});

		firstTime = false;

		if ($('.products-page').length) {
			delete window.cartItems;
		}
	}

	$('.prod_card.-is-selected').each(function (o) {
		if ($(this).data('setup-cost')) {
			if ($(this).find('.product_qty > input').length) {
				setupCost = setupCost + (parseFloat($(this).data('setup-cost')) * $(this).find('.product_qty > input').val());
			} else {
				console.log('test3');
				setupCost = setupCost + parseFloat($(this).data('setup-cost'));
			}
		}
	});

	setupCost = setupCost.toFixed(2).toString();
	let decimal = setupCost.substring(setupCost.indexOf('.'));
	let s = '<span><sup>$</sup></span>' + setupCost.substring(0, (setupCost.indexOf('.'))) + '<span>' + (decimal != '' ? decimal : '.00') + '</span>';
	payableCost.html(s);
}



// WEBPACK FOOTER //
// ./source/scripts/directives/action/checkout.js